import React from "react";
import SpecialDaysCreateEditTemplate from "../../../../components/templates/specialDays/specialDaysCreateEditTemplate";
import {useStores} from "../../../../stores/useStores";
import {useTranslation} from "react-i18next";
import {ToastMessageStatus} from "../../../../components/atoms/toastMessage/toastMessage";
import Occasion from "../../../../stores/domainStore/pages/models/occasion";

// Testing this file means mocking almost everything, it's integration testing, not unit testing
/* istanbul ignore file */
const CreateSpecialDay: React.FC = () => {
  const {
    uiStore: {toastMessageStore},
    domainStore: {occasionDomainStore}
  } = useStores();
  const {t} = useTranslation(["specialDays"]);

  const createSpecialDayAsync = async (payload: Occasion) => {
    try {
      await occasionDomainStore.createOccasion(payload);
      toastMessageStore.displayToastMessage(
        t("specialDays:messages.createdSpecialDay", {
          occasionTitle: payload.title.text
        }),
        ToastMessageStatus.Success
      );
    } catch {
      toastMessageStore.displayToastMessage(
        t("specialDays:messages.createdSpecialDayFailure", {
          occasionTitle: payload.title.text
        }),
        ToastMessageStatus.Danger
      );
      throw new Error();
    }
  };

  return <SpecialDaysCreateEditTemplate onPublish={createSpecialDayAsync} />;
};

export default CreateSpecialDay;
